export class MissingTrainingRefresh {
  static readonly type = "[MissingTraining] Refresh";
  constructor(public id: number) { }
}
